<template>
  <div class="padding-card grey">
    <v-card class="padding-card">
      <v-row>
        <v-col>
          <p class="title-user-scr"> <v-icon> mdi-filter </v-icon>Filtros</p>
        </v-col>
        <v-col>
           <v-btn depressed @click="cleanFilter" color="primary" dark>Limpiar Filtro</v-btn>      
           <v-btn depressed @click="regresar" class="ml-3">Regresar</v-btn>     
        </v-col>
        
      </v-row>
      <v-form ref="formFilters">
        <div>
          <v-row>
            <v-col>
              <v-autocomplete
                item-text="concept"
                item-value="id"
                label="Plan"
                v-model="filter.maintenanceFeeId"
                :items="paymentPlans"
              />
            </v-col>
          </v-row>

          <v-row>   
              <v-col>
                 <DateSelect 
                    v-model="dates"                    
                    @change="updateFilterDates" 
                    :rules="rules.dateRange" />
              </v-col>
              <v-col>       
                <v-autocomplete
                    dense                 
                    v-model="filter.paymentMethod"
                    :items="paymentTypes"
                    item-text="title"
                    item-value="value"           
                    label="Forma de pago"
                  >
                </v-autocomplete>    
              </v-col> 
            </v-row>            
          </div>
          <div style="margin:30px">
            <v-divider></v-divider>
          </div>
          
        <v-card-actions style="margin-top: 1.5rem;">
          <v-btn depressed @click="printReport" color="#00aff2" dark>Vista Previa</v-btn>
          <v-spacer></v-spacer>          
        </v-card-actions>
      </v-form>
    </v-card>
  </div>  
</template>

<script>

import DateSelect from '@/components/DateSelect2.vue';
import adminMaintenanceService from '@/services/admin/maintenancePayments';

export default {
  name: 'SpendReportForm',  
  components: {    
    DateSelect,
  },
  data() {    
    return {      
      paymentPlans: null,
      planSelected: null,
      dates: [],
      filter:{
        paymentMethod: null,
        maintenanceFeeId: null,     
        date: null         
      },   
      paymentTypes: [{ title: 'Cash en oficina', value: 'cash' }, { title: 'Tarjeta credito/debito', value: 'stripe' },
        { title: 'Deposito o transferencia', value: 'Bank Transfer' }
      ],
     
      rules: {         
          dateRange: [
              v => !v || v.length !== 2 || !v[0] || !v[1] || v[0] <= v[1] || 'La fecha inicial debe ser menor o igual que la fecha final',
            ]         
        },        
    }
  },
  mounted() {
    this.fetchPaymentPlans();
    this.dates = [
      this.$dayjs().format('YYYY-MM-DD'),
      this.$dayjs().add(30, 'day').format('YYYY-MM-DD')
    ];
  },
  methods: {   
    fetchPaymentPlans() {
     // const year = new Date(this.dates[1]).getFullYear();
      adminMaintenanceService.fetch().then((response) => {
        this.paymentPlans = response.data;
        this.filter.maintenanceFeeId = this.paymentPlans.length ? this.paymentPlans[0].id : null;
      });     
    },
    printReport() {     
      if(!this.$refs.formFilters.validate())  {
        console.log('forma invalida');
        return;  
      }               
      let opts = this.filterNonNullValues(this.filter);   
      console.log(opts);    
      adminMaintenanceService.getDataRep(opts)
        .then((response) => {
          const dataRep = response.data;   
          if (dataRep.length > 0 ) {
            this.$router.push({
                  name: 'incomereport',
                  params: {                
                    dataRep: dataRep
                  }
              });  
           } else {
            this.$swal('', 'No se encontrarón movimientos con ese criterio. Se recomienda "Limpiar Filtros".', 'warning');
           }     
        })
        .catch((err)=>{
          this.$swal('Error', err.response.data.message, 'warning');
        });
    },
    buildFilterOpt(opts) {
      const newObj = {};
      for (const [key, value] of Object.entries(opts)) {        
          newObj[key] = value;           
      }            
      return newObj;      
    },
    filterNonNullValues (obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(([, value]) => {               
          return value !== null && value !== '';
        })
      );
    },   
    cleanFilter() {
      this.filter = {
          maintenanceFeeId: null,
          dates:null,
          paymentMethod: null, 
        };        
    },
    updateFilterDates(dates) {
      this.filter.dates = dates;
      this.dates = dates;
    },
    regresar(){
      this.$router.push({ name: 'income' });
    },
}}
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>